import * as React from 'react';
import { Grid, Dimmer, Loader } from 'semantic-ui-react';
import { UserForm } from 'components/user-form';
import { LanguageCode } from 'types/tenants/language-code';
import { User } from 'types/user';
import { Guid } from 'types/guid';
import { UserManagementMode } from 'types/user-management-mode';

import './styles.css';
import { Scrollable } from 'components/scrollable/component';

export interface Props {
  isOnline: boolean;
  isProcessing: boolean;
  isProcessingPasswordReset: boolean;
  isLoadingProfileInfo: boolean;
  language: LanguageCode;
  user: User;
  errorMessage: string;
  permissions: string;
  getUserProfile: (userId: Guid) => void;
  updateUserProfile: (userId: Guid, user: User) => void;
  setUserErrorMessage: (errorMessage: string) => void;
}

export class UserProfilePage extends React.Component<Props, object> {

  constructor(props: Props) {
    super(props);
  }

  componentWillMount() {
    this.props.setUserErrorMessage('');
    // if page is loading for first time (refresh) user profile gets set from RefreshTokenAction
    if (this.props.user && this.props.user.id) {
      this.props.getUserProfile(this.props.user.id);
    }
  }

  public render() {
    return (
      <Scrollable>
        <Grid columns={1} padded="horizontally" className="form-page user-profile-page">
          <Dimmer active={this.props.isProcessing || this.props.isProcessingPasswordReset}>
            <Loader />
          </Dimmer>
          <Grid.Row>
            <Grid.Column width={16} className="padding-right">
              <Grid className="panel">
                <Grid.Row>
                  <Grid.Column computer={10} mobile={16}>
                    <UserForm
                      isProcessing={this.props.isProcessing || this.props.isProcessingPasswordReset}
                      isFirstLoading={this.props.isLoadingProfileInfo}
                      user={this.props.user}
                      errorMessage={this.props.errorMessage}
                      saveUser={this.props.updateUserProfile}
                      mode={UserManagementMode.profile} />
                  </Grid.Column>
                </Grid.Row>
              </Grid>
            </Grid.Column>
          </Grid.Row>
        </Grid >
      </Scrollable>
    );
  }
}


// WEBPACK FOOTER //
// ./src/pages/user-profile/component.tsx